<template>
  <filter-bar>
    <div style="width: 100%; display: flex;" class="md-layout">
      <div class="md-layout-item md-size-10 md-small-size-50">
        <md-field>
          <label for="dateFrom">
            <md-icon>calendar_today</md-icon>
            <span v-show="!dateFrom">Desde</span>
          </label>
          <datetime
            input-style="border: none; outline:none; width: 100%"
            type="date"
            title="Desde"
            value-zone="America/Mexico_City"
            v-model="value.dateFrom"
            :phrases="{ ok: '', cancel: '' }"
            auto
            :disabled="loading"
          ></datetime>
          <!-- <md-button class="md-simple md-just-icon" @click="value.dateFrom = null">
            <md-icon>close</md-icon>
          </md-button>-->
        </md-field>
      </div>
      <div class="md-layout-item md-size-10 md-small-size-50">
        <md-field>
          <label for="dateOccurred">
            <md-icon>calendar_today</md-icon>
            {{ dateTo ? "" : "Hasta" }}
          </label>
          <datetime
            input-style="border: none; outline:none; width: 100%"
            type="date"
            title="Hasta"
            value-zone="America/Mexico_City"
            v-model="value.dateTo"
            :phrases="{ ok: '', cancel: '' }"
            auto
            :disabled="loading"
          ></datetime>
          <!-- <md-button class="md-simple md-just-icon" @click="value.dateTo = null">
            <md-icon>close</md-icon>
          </md-button>-->
        </md-field>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100">
        <multiselect
          v-model="value.iwarehouses"
          multiple
          :closeOnSelect="false"
          track-by="id"
          :options="catalogs.iwarehouses"
          label="name"
          :disabled="loading"
          placeholder="Almacenes"
          deselect-label="Remover"
          select-label="Click para seleccionar"
          selected-label="Seleccionado"
        />
      </div>
      <div class="md-layout-item md-size-15 md-small-size-50">
        <md-field style="width: 100%;">
          <label>Tipo de movimiento</label>
          <md-select :disabled="loading" v-model="value.movementType">
            <md-option
              v-for="MType in movementsType"
              :key="MType.id"
              :value="MType.slug"
            >{{ MType.name }}</md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-15 md-small-size-50">
        <md-field>
          <label>Motivos de movimiento</label>
          <md-select
            :disabled="value.movementType === 'all' || loading"
            v-model="value.movementReason"
          >
            <md-option
              v-for="reason in reasonsOfMovementFiltered"
              :key="reason.id"
              :value="reason.slug"
            >{{ reason.name }}</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <md-menu md-size="small">
      <md-button md-menu-trigger class="md-just-icon md-simple">
        <md-icon>more_vert</md-icon>
      </md-button>

      <md-menu-content>
        <md-menu-item class="md-info" @click="$emit('downloadReport')">
          <md-icon style="margin-right: 8px;" class="fa fa-file-excel"></md-icon>Descargar Excel
        </md-menu-item>
      </md-menu-content>
    </md-menu>
    <template v-slot:actions>
      <md-switch
        style="width: 240px;"
        :disabled="loading"
        v-model="value.queryMode"
      >Buscar por Siniestro</md-switch>

      <md-button style="width: 240px;" :disabled="loading" @click="submitFitlers">Buscar</md-button>
    </template>
  </filter-bar>
</template>
<script>
import FilterBar from "@/components/FilterBar";

import moment from "moment";

const movementsType = [
  {
    id: 1,
    slug: "all",
    name: "Todas",
  },
  {
    id: 2,
    slug: "in",
    name: "Entradas",
  },
  {
    id: 3,
    slug: "out",
    name: "Salidas",
  },
];

const reasonsOfMovement = [
  {
    id: 1,
    slug: "all",
    name: "Todas",
    movementType: "in",
  },
  {
    id: 2,
    slug: "all",
    name: "Todas",
    movementType: "out",
  },
  {
    id: 3,
    slug: "oc",
    name: "OC",
    movementType: "in",
  },
  {
    id: 4,
    slug: "devo",
    name: "Devoluciones",
    movementType: "in",
  },
  {
    id: 5,
    slug: "transfersInputs",
    name: "Traspasos",
    movementType: "in",
  },
  {
    id: 6,
    slug: "byadjustment",
    name: "Ajustes",
    movementType: "in",
  },
  {
    id: 7,
    slug: "noOC",
    name: "Sin OC",
    movementType: "in",
  },
  {
    id: 8,
    slug: "out",
    name: "Salidas normales",
    movementType: "out",
  },
  {
    id: 9,
    slug: "extraouts",
    name: "Salidas extras",
    movementType: "out",
  },
  {
    id: 10,
    slug: "transfersouts",
    name: "Traspasos",
    movementType: "out",
  },
  {
    id: 11,
    slug: "byadjustment",
    name: "Ajustes",
    movementType: "out",
  },
];

export default {
  components: {
    FilterBar,
  },
  props: {
    value: {
      required: true,
      type: Object,
      default: () => {},
    },
    catalogs: {
      required: true,
      type: Object,
      default: () => {},
    },
    defaults: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { dateFrom, dateTo } = this.defaults;
    return {
      dateFrom:
        dateFrom === undefined
          ? moment().subtract(15, "days").format("YYYY-MM-DD")
          : value.dateFrom,
      dateTo:
        dateTo === undefined ? moment().format("YYYY-MM-DD") : value.dateTo,
      selectedReason: null,
      movementsType,
      reasonsOfMovement,
    };
  },
  computed: {
    reasonsOfMovementFiltered() {
      const selectedMovement = this.value.movementType;

      return reasonsOfMovement.filter(
        (r) => selectedMovement == r.movementType
      );
    },
  },
  methods: {
    submitFitlers() {
      this.$emit("submitFitlers");
    },
  },
};
</script>
<style lang="scss" scoped>
.md-layout-item {
  padding: 0 8px;
}
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.before-list-item {
  font-size: 1.6rem;
  padding: 8px 0px 8px 10px;
}
.before-list-item:hover {
  cursor: pointer !important;
  background-color: red;
  font-weight: bold;
  color: white;
}

.md-menu-content :deep(.md-list-item-content) {
  padding: 0 !important;
}
.md-switch {
  margin: unset;
}
</style>



// WEBPACK FOOTER //
// src/pages/Reports/InputsOutputsReport/Filters.vue